import React, {useEffect, useState} from 'react';
import App from "layouts/app";
import {get} from "../../../class/helper";
import {Link} from "react-router-dom";
import {RotateSpinner} from "react-spinners-kit";

const Packages = () => {
		const [packages, setPackages] = useState(null);
		const [error, setError] = useState(null);
		const [loading, setLoading] = useState(true);

		useEffect(() => {
			get("/packages", true).then(r => {
				if (r.error) {
					setError(r.data)
					setLoading(false)
				} else {
					setPackages(r.data.packages)
					setLoading(false)
				}
			})
		}, []);


		return (
			<App>
				{!loading ?
					<>
						{packages?.length > 0 ?
							<div className={"grid lg:grid-cols-3 grid-cols-1 gap-2 w-full p-2"}>
								{packages.map((curPackage, i) => {
									return (
										<div key={i}>
											<Link className={"group flex flex-col p-2 bg-gray-100"} to={"/app/packages/" + curPackage._id} key={i}>
												{curPackage.thumbnail &&
												<div className={"bg-gray-200 h-48 w-full rounded-sm"}>
													<img src={curPackage.thumbnail} alt={curPackage.title} className={"h-48 rounded-sm object-contain mx-auto"}/>
												</div>
												}
												<div className={"text-black text-xl text-gray-600"}>{curPackage.title}</div>
												<div className={"text-black text-sm text-gray-400"}>{curPackage.description}</div>
											</Link>
										</div>
									)
								})}
							</div>
							:
							<>
								{error ?
									<div className="flex w-full h-full justify-center items-center">
										<div className="text-base font-medium text-gray-500 py-16">{error}</div>
									</div>
									:
									<div className="flex w-full h-full justify-center items-center">
										<div className="text-base font-medium text-gray-500 py-16">There are no packages available to you.</div>
									</div>
								}
							</>
						}
					</>
					:
					<div className="flex w-full h-full justify-center items-center">
						<RotateSpinner size={30} color="#374151" loading={loading}/>
					</div>
				}
			</App>
		);
	}
;

export default Packages;
